import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
const Select = ({ id, name, value, options, onChange, disabled, }) => (_jsx("select", { id: id, name: name, value: value, onChange: onChange, disabled: disabled, className: "shadow-sm block w-full sm:text-sm rounded-md focus:ring-aptivegreen focus:border-aptivegreen border-gray-300 placeholder-gray-300", autoComplete: "off", children: options.map(({ name, value, }) => (_jsx("option", { value: value, children: name }, value))) }));
Select.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    options: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })),
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
};
export default Select;
